import React from 'react' 
import clsx from 'clsx'
// import I18n from 'i18n-js/index.js.erb'

class ReplyBuilderGeneral extends React.Component {

  constructor(props) {
    super(props);
  }

  /*******************
  * Render functions *
  ********************/

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="general">
        <div className="row">
          <div className="col-md-12">
            {this.renderGeneralForm()}
          </div>
        </div>
      </div>
    )
  }

  renderGeneralForm() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-2">
            <div className="form-group">
              <label>{`${I18n.t('code')}*`}</label>
              <input
                type="text"
                maxLength="12"
                name="code"
                className={this.renderFieldClasses('code')}
                value={this.props.reply.code || ''}
                onChange={this.props.onChangeField}
              />
              {this.renderFieldErrors('code')}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{`${I18n.t('name')}*`}</label>
              <input
                type="text"
                name="name"
                className={this.renderFieldClasses('name')}
                value={this.props.reply.name || ''}
                onChange={this.props.onChangeField}
              />
              {this.renderFieldErrors('name')}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>{I18n.t('status')}</label>
              <select
                id="status"
                name="status"
                value={this.props.reply.status || ''}
                onChange={this.props.onChangeField}
                className={this.renderFieldClasses('status', false)}>
                <option value="enabled">{I18n.t('enabled')}</option>
                <option value="disabled">{I18n.t('Disabled')}</option>
              </select>
              {this.renderFieldErrors("status")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-9">
            <div className="form-group">
              <label>{I18n.t('body')}</label>
              <textarea name="body" className="form-control" value={this.props.reply.body || ''} onChange={this.props.onChangeBody}/>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      })
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control'
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors'
    }
    return classname
  }

}
export default ReplyBuilderGeneral